import initialMockSettingsData from "./utilities/initialMockSettingsData";

const getAdminSettings = () => {
  let resp = {
    isApp: false,
    success: true,

    userCanViewFamilyRegistrationPanel: true,
    networkHasFNC: false,
    // networkHasFundIt: false,

    userIsSuperAdmin: true,
    familyRegistrationIsLive: true,
    networkHasFamilyRegistration: true,
    networkHasFundIt: true,
    networkHasMembershipStatus: true,
    canEditMembershipStatusOptions: true,

    familyRegistrationSettings: initialMockSettingsData,
    // canEditMembershipStatusOptions: true,
    // networkHasMembershipStatus: true,
    // networkHasFamilyRegistration: true,
    everyoneGroupID: 7,
  };

  return resp;
};

export default getAdminSettings;
